import React from 'react';
import { isMobile } from 'react-device-detect';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Link } from 'react-router'
import Image from 'components/Image';

import {
	IconTitle,
	HeaderSection,
	CustomTabBar,
	MobileTabBar,
} from '../../components';
import STRINGS from '../../config/localizedStrings';
import { EditWrapper } from 'components';
import withConfig from 'components/ConfigProvider/withConfig';

const VerificationHome = ({
	activeTab,
	tabProps,
	tabs,
	openContactForm,
	setActiveTab,
	renderContent,
	icons: ICONS,
}) => {
	// if (activeTab < tabs.length) {
	return (
		<div className="presentation_container apply_rtl verification_container">
			{/* {!isMobile && (
				<IconTitle
					stringId="ACCOUNTS.TAB_VERIFICATION"
					text={STRINGS['ACCOUNTS.TAB_VERIFICATION']}
					textType="title"
					iconPath={ICONS['TAB_VERIFY']}
					iconId={STRINGS['ACCOUNTS.TAB_VERIFICATION']}
				/>
			)} */}
			<div className="header_title-wrapper d-flex flex-column w-100 f-1">
				<div className="d-flex justify-content-between ws-trade-head">
					<div className="d-flex align-items-center">
						<div className="ws-lock d-lg-flex d-none">
							<Image icon={process.env.PUBLIC_URL + "/assets/images/check.png"} />
						</div>
						<div className="d-flex flex-column pl-4">
							<span className='ws-trade-tabe-head'>
								Verification
							</span>
							<span className='ws-trade-tabe-p'>
							{STRINGS['USER_VERIFICATION.INFO_TXT']} 		{STRINGS['USER_VERIFICATION.INFO_TXT_1']}
							</span>
						</div>
					</div>
					<div className='d-lg-flex d-none align-items-center'>

						<span className="trade_tabs-link">
							<Link to="/wallet">Need Help?</Link>
						</span>
					</div>
				</div>
			</div>
			<div className="inner-content">
				{!isMobile ? (
					<CustomTabBar
						activeTab={activeTab}
						setActiveTab={setActiveTab}
						{...tabProps}
					/>
				) : (
					<MobileTabBar
						activeTab={activeTab}
						renderContent={renderContent}
						setActiveTab={setActiveTab}
						{...tabProps}
					/>
				)}
				{!isMobile ? (
					<div className="inner_container">
						{activeTab > -1 && renderContent(tabs, activeTab)}
					</div>
				) : null}
			</div>
		</div>
	);
	// } else {
	//     return (
	//         <div className="presentation_container apply_rtl verification_container">
	//             {!isMobile && <TabController {...tabProps} />}
	//             <div className="inner_container">complete</div>
	//         </div>
	//     )
	// }
};

export default connect(null)(withConfig(VerificationHome));
